import React, { Component, createRef, Fragment } from "react";
import { connect } from "react-redux";
import {
  transFetchData,
  getUserPlayedGameDays,
  fixturesFetchData,
  mixFetchData,
  showHidePopup,
  getMy11LoginDetails,
  postApiMy11Logout,
  fetchBoostersCon,
  fetchBadges,
  fetchUserBadges,
  setWrapperRef,
  resetStore,
  fetchConfigData,
} from "./../../redux/actions/appActions";
import config from "./../../common/config";
import app from "./../../common/app";
import core from "./../../common/core";
import Routes from "./../routes";
import Loader from "./../loader";
import ErrorBoundary from "./../errorBoundary";
import PopupAlert from "./../popupAlert";
import OverlayAlertTeam from "./../overlayAlertTeam";
import ErrorPage from "./../supportPages/errorPage";
import PullToRefreshBasic from "./pullToRefresh";
import Trans from "../../componentsReusable/trans";

let matchLandingIntervalCount = null;
class Wrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      goAhead: false,
      objInvite: {},
      propsAlert: { isShow: false, message: "" },
      propsAlertTeam: { isShow: false, message: "" },
      isShowErrorPage: false,
    };
    this.wrapRef = createRef();
  }
  showHideAlert = (isShow, titleText, bodyText, sClass, fnCallback) => {
    let sClassName = "";
    if (isShow) {
      sClassName = "m11c-show" + " " + sClass;
    }
    let showHideAlert = this.showHideAlert;
    if (fnCallback) {
      showHideAlert = () => {
        this.showHideAlert();
        fnCallback();
      };
    }
    this.setState((state, props) => {
      return {
        propsAlert: {
          isShow: isShow,
          titleText: titleText,
          bodyText: bodyText,
          sClass: sClassName,
          showHideAlert: showHideAlert,
        },
      };
    });
  };
  showHideAlertTeam = (
    isShow,
    titleText,
    bodyText,
    bodyText1,
    sClass,
    hideHeader = false
  ) => {
    let sClassName = "";
    if (isShow) {
      sClassName = "m11c-show" + " " + sClass;
    }
    this.setState((state, props) => {
      return {
        propsAlertTeam: {
          isShow: isShow,
          titleText: titleText,
          bodyText: bodyText,
          bodyText1: bodyText1,
          sClass: sClassName,
          hideHeader: hideHeader,
        },
      };
    });
  };
  showHidePopup = () => {
    const self = this;
    let nodePopup = null;
    const objPopup = self.props.objPopup;
    if (objPopup) {
      var clonedElementWithMoreProps = React.cloneElement(
        objPopup.component ? objPopup.component : <div />,
        { isShow: objPopup.isShow }
      );
      nodePopup = clonedElementWithMoreProps;
    }
    return nodePopup;
  };

  callIntervalForMixAPI = (isInitialCall) => {
    const self = this;
    window.clearInterval(matchLandingIntervalCount);
    //call Live Scoring API here.
    self.init(isInitialCall);
    /*  matchLandingIntervalCount = window.setInterval(function () {
             self.init(false);
         }, config.mixApiLiveInterval); */
  };
  render() {
    const self = this;
    const { showHideAlert, showHideAlertTeam, props, state } = self;
    const { propsAlert, propsAlertTeam, isShowErrorPage } = state;

    const nodeLoader = (
      <div className="m11c-cmo__wrap">
        <div className="m11c-cmo__lhs">
          <Loader />
        </div>
      </div>
    );
    let nodeBody = self.state.goAhead ? (
      <Routes
        {...props}
        showHideAlert={showHideAlert}
        showHideAlertTeam={showHideAlertTeam}
        nodeLoader={nodeLoader}
      />
    ) : (
      nodeLoader
    );
    //const nodePopup = self.showHidePopup();
    if (isShowErrorPage) {
      nodeBody = <ErrorPage />;
    }
    let ParentComponent = Fragment;
    let propsParentComponent = null;
    const isWebView = app.isWebView();
    if (isWebView) {
      const { objMix, isShowPullToRefresh } = props;
      propsParentComponent = {
        resetStore: props.resetStore,
        objMix,
        isShowPullToRefresh,
      };
      ParentComponent = PullToRefreshBasic;
    }
    return (
      <ParentComponent {...propsParentComponent}>
        <ErrorBoundary>
          <div className="m11c-main" ref={this.wrapRef}>
            <div className="m11c-main__bg">
              <div className="m11c-main__bg-box">
                <div className="m11c-main__bg-thumb">
                  <img src={`${config.IMG_BASE}main-logo-rhs.png`} alt="" />
                </div>
                <div className="m11c-main__bg-title">
                  {/* <span>WELCOME TO THE OFFICIAL</span> */}
                  {/* <span>FANTASY GAME OF THE</span> */}
                  <span>OFFICIAL SEASON LONG FANTASY 2025</span>
                </div>
              </div>
            </div>
            {nodeBody}
            {
              //nodePopup
            }
            <PopupAlert {...propsAlert} />
            {propsAlertTeam.isShow && (
              <OverlayAlertTeam
                {...propsAlertTeam}
                showHideAlertTeam={showHideAlertTeam}
              />
            )}
          </div>
        </ErrorBoundary>
      </ParentComponent>
    );
    // return <Routes trans={trans} />;
  }
  init = (isInitialCall) => {
    const self = this;
    const { mixFetchData, arrFixtures, objMix: objMixOld } = self.props;
    const cookie = app.getLoginCookie();

    const mixFetchDataAPI = mixFetchData({ isNotShowLoader: false });
    mixFetchDataAPI
      .then((resp) => {
        if (
          resp &&
          resp.value.data &&
          resp.value.data.Data &&
          resp.value.data.Data.Value
        ) {
          const objMix = resp.value.data.Data.Value;
          if (objMix) {
            const {
              LiveFixture,
              AbandonedGameDayId,
              FreezeGamedayId,
              VersionMaster,
              BadgeVersion,
              JsVersion,
            } = objMix;
            let isSame = app.isFixtureChanged(
              arrFixtures,
              LiveFixture,
              AbandonedGameDayId,
              FreezeGamedayId,
              VersionMaster,
              objMixOld,
              JsVersion
            );
            if (isInitialCall) {
              const transPromise = self.props.transFetchData();
              const fixturesPromise = self.props.fixturesFetchData({
                VersionMaster,
              });
              if (cookie) {
                const getUserPlayedGameDaysAPI =
                  self.props.getUserPlayedGameDays();
                // const fetchBoostersConAPI = self.props.fetchBoostersCon({
                //   VersionMaster,
                // });
                //badges

                const fetchBadgesAPI = this.props.fetchBadges({
                  VersionMaster,
                });
                const fetchConfigAPI = this.props.fetchConfigData({
                  VersionMaster,
                });
                let fetchUserBadgesAPI;
                if (window.location.href.includes("/badges")) {
                  let paramsBadge = {
                    optType: config.enumOptTypeBadge.default,
                    BadgeVersion,
                  }; //
                  fetchUserBadgesAPI = this.props.fetchUserBadges(paramsBadge);
                  fetchUserBadgesAPI.then(() => {
                    self.setState({ goAhead: true });
                  });
                }
                //console.log(BadgeVersion)
                const arrAPIs = [
                  transPromise,
                  getUserPlayedGameDaysAPI,
                  fixturesPromise,
                  // fetchBoostersConAPI,
                  fetchBadgesAPI,
                  fetchConfigAPI,
                  fetchUserBadgesAPI,
                ];
                Promise.all(arrAPIs)
                  .then((resp) => {
                    if (
                      resp &&
                      resp.length &&
                      resp[0].value.data &&
                      resp[0].value.data.value &&
                      resp[1].value.data &&
                      resp[1].value.data.Data &&
                      resp[1].value.data.Data.Value &&
                      resp[3].value.data &&
                      resp[3].value.data.Data &&
                      resp[3].value.data.Data.Value
                    ) {
                      const arrBoostersConstraint =
                        resp[3].value.data.Data.Value;

                      // CHANGE HERE
                      // arrBoostersConstraint.push({
                      //   Id: 5,
                      //   Name: "bst5gd",
                      //   DispName: "Double Points",
                      //   ExpDateTime:
                      //     "Fri Feb 25 2022 05:30:00 GMT+0530 (India Standard Time)",
                      //   IsActive: true,
                      // });

                      // for (let i = 0; i < arrBoostersConstraint.length; i++) {
                      //   const element = arrBoostersConstraint[i];

                      //   if (element.Name == "bst4gd") {
                      //     element.ExpDateTime =
                      //       "Mon Feb 28 2022 17:01:40 GMT+0530 (India Standard Time)";
                      //   }
                      // }
                      if (arrBoostersConstraint) {
                        // console.log(config.enumBoosterTexts)

                        // app.boosterValUpdate(arrBoostersConstraint);
                        // arrBoostersConstraint.forEach((element) => {
                        //   if (config.enumBoosterTexts[element.Name]) {
                        //     config.enumBoosterTexts[element.Name].id =
                        //       element.Id;
                        //   }

                        //   if (
                        //     element.IsActive &&
                        //     element.Id ==
                        //       config.enumBoosterTexts[element.Name].id &&
                        //     config.enumBoosterTexts[element.Name].isPerish
                        //   ) {
                        //     config.enumBoosterTexts[
                        //       element.Name
                        //     ].isActive = true;

                        //     let timeMain = core.convertTimeToOffsetNew(
                        //       element.ExpDateTime,
                        //       config.offSetToAdd
                        //     );

                        //     config.enumBoosterTexts[element.Name].tillDate =
                        //       timeMain;

                        //     // config.enumBoosterTexts[element.Name].tillDate =
                        //     //   element.ExpDateTime;
                        //   }
                        // });
                        //
                        const { IsHomeHiddenWeb, IsHomeHiddenWebView } =
                          objMix || {};
                        let IsHideBadgeFromHome = IsHomeHiddenWeb;
                        const isWebView = app.isWebView();
                        if (isWebView) {
                          IsHideBadgeFromHome = IsHomeHiddenWebView;
                        }
                        const objUserPlayedGameDays =
                          resp[1].value.data.Data.Value;
                        if (
                          IsHideBadgeFromHome &&
                          window.location.pathname.includes(
                            `${config.URL_BASE}${config.enumStaticUrls.home}`
                          )
                        ) {
                          self.setState({ goAhead: true });
                        } else if (
                          objUserPlayedGameDays &&
                          objUserPlayedGameDays.ftgdid
                        ) {
                          let paramsBadge = {
                            optType: config.enumOptTypeBadge.default,
                            BadgeVersion,
                          }; //
                          if (
                            window.location.pathname.includes(
                              `${config.URL_BASE}${config.enumStaticUrls.badges}`
                            )
                          ) {
                            paramsBadge = { ...paramsBadge, isBadgeOnly: 1 };
                          }
                          self.setState({ goAhead: true });
                          const fetchUserBadgesAPI =
                            this.props.fetchUserBadges(paramsBadge);
                          fetchUserBadgesAPI.then(() => {
                            self.setState({ goAhead: true });
                          });
                        } else {
                          self.setState({ goAhead: true });
                        }
                      }
                    }
                  })
                  .catch((reason) => {
                    console.log(reason);
                  });
              } else {
                Promise.all([transPromise, fixturesPromise])
                  .then((resp) => {
                    if (
                      resp &&
                      resp.length &&
                      resp[0].value.data &&
                      resp[0].value.data.value
                    ) {
                      self.setState({ goAhead: true });
                    }
                  })
                  .catch((reason) => {
                    console.log(reason);
                  });
              }
            } else {
              if (!isSame) {
                //Auto refresh.
                console.log('Auto refreshing "VersionMaster" changed');
                //core.CompCacheBusterCookie(config.enumBusters.autorefresh);
                const fixturesPromise = self.props.fixturesFetchData({
                  VersionMaster,
                });
                fixturesPromise
                  .then((respF) => {
                    /* if (respF && respF.value.data && respF.value.data.Data && respF.value.data.Data.Value) {

                    } */
                  })
                  .catch((reason) => {
                    console.log(reason);
                  });
              }
            }
          }
        }
      })
      .catch((reason) => {
        console.log(reason);
      });
  };
  callLogin = (authToken, uid) => {
    let SSId = core.getCookie(config.SSID_TOKEN);
    const self = this;
    let platformId = config.enumPlatforms.web;
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    //let allParams = decodeURIComponent(queryString);
    let isIn = urlParams.get("isIn");

    let loginPayload = {
      optType: 0,
      //platformId: platformId,
      userId: 0,
      clientId: 1,
      socialId: uid,
      fullName: "",
      teamName: "",
      authtoken: authToken,
      guid: "",
      teamId: 0,
      favTeamId: 0,
      ssid: SSId ? 1 : 0,
      isIndianUser: isIn == "true" ? 1 : 0,
      platformId: app.isWebView() ? 1 : 3,
    };

    const appType = app.getAppType();
    if (appType === config.enumWebView.android) {
      platformId = config.enumPlatforms.android;
    } else if (appType === config.enumWebView.ios) {
      platformId = config.enumPlatforms.ios;
    }
    const My11Login = self.props.getMy11LoginDetails(loginPayload);
    My11Login.then((resp) => {
      // console.log("<-<-<-<-<  api call made");
      //alert(resp);
      let newCookie = app.getLoginCookie();
      let isValidNewCookie = newCookie && newCookie.SocialId;
      if (isValidNewCookie) {
        // console.log("<-<-<-<-<  cookie present after My11-login api call");
        self.callIntervalForMixAPI(true); // logged in user
      } else {
        // console.log("<-<-<-<-<  cookie invaild after My11-login api call");
        // self.callLogout();
      }
    }).catch((reason) => {
      //alert(reason);
      console.log(reason);
      // console.log("<-<-<-<-<  My11-login api failed");
      // self.callLogout();
    });
  };
  callLogout = () => {
    const self = this;
    // commented 👇
    self.deleteClientCookie();
    self.callIntervalForMixAPI(true); // logged out user
    /* let logoutApi = self.props.postApiMy11Logout();
        logoutApi.then(respF => {
            let resLogout = (respF && respF.value && respF.value.data && respF.value.data.data && respF.value.data.data.logout && respF.value.data.data.logout.successful) ? respF.value.data.data.logout.successful : null;
            let isSuccess = (resLogout == "true");
            if (isSuccess) {
                self.deleteClientCookie();
                self.init(); // logged out user
            }
        }).catch(reason => {
            console.log(reason);
            self.init();
        }); */
  };
  loginCheck = () => {
    const self = this;
    // const csrf = core.getCookie(config.COOKIE_CSRF);
    const authToken = core.getCookie(config.COOKIE_AUTHTOKEN);
    const uid = core.getCookie(config.COOKIE_UID);
    const cookie = app.getLoginCookie();
    const isValidCookie = cookie && cookie.SocialId && cookie.HasTeam === 1;
    const Version = cookie && cookie.Version;
    const isSameV = Version == config.VersionCookie;

    if (authToken && uid) {
      self.callLogin(authToken, uid);
    } else {
      if (isValidCookie) {
        // console.log("<-<-<-<-<  __csrf absend, my11_classic_game present");
        // delete my11_classic_game cookie and send user to login link
        self.callLogout();
      } else {
        // console.log("<-<-<-<-<  __csrf absend, my11_classic_game absend");
        self.callIntervalForMixAPI(true); // logged out user
      }
    }
  };
  deleteClientCookie = () => {
    // delete my11_classic_game cookie here
    app.deleteAllCookies();
  };
  componentDidMount() {
    config.initialLoad = true;
    this.loginCheck();
  }
  componentDidUpdate(prevProps, prevState) {
    const { setWrapperRef } = this.props;
    if (!prevState.goAhead && this.state.goAhead) {
      setWrapperRef(this.wrapRef);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { jErrorcode: jErrorcodeOld } = this.props;
    const { jErrorcode, trans } = nextProps;
    if (jErrorcodeOld !== jErrorcode) {
      const fnRedirect = () => {
        app.deleteAllCookies();
        if (
          window.location.pathname.indexOf(
            config.URL_BASE + config.enumStaticUrls.home
          ) === -1
        ) {
          window.location.href =
            window.location.origin +
            config.URL_BASE +
            config.enumStaticUrls.home;
        }
      };
      if (jErrorcode === config.enumErrorCode.isToast) {
        if (
          window.location.pathname.indexOf(
            config.URL_BASE + config.enumStaticUrls.home
          ) === -1 &&
          !window.location.href.includes("tnc")
        ) {
          const sMessage =
            trans && trans.sessionExpired
              ? trans.sessionExpired
              : "Session expired. Please login again.";
          this.showHideAlert(true, sMessage, "", "m11c-danger", fnRedirect);
        } else {
          app.deleteAllCookies();
          this.callIntervalForMixAPI(true);
        }
      } else if (jErrorcode === config.enumErrorCode.isRedirect) {
        //fnRedirect();
        // this.setState((state, props) => {
        //   return {
        //     isShowErrorPage: true,
        //   };
        // });
      }
    }
  }
  componentWillUnmount() {
    window.clearInterval(matchLandingIntervalCount);
  }
}
const mapStateToProps = (state) => {
  return {
    trans: state.appData.trans,
    objPopup: state.appData.objPopup,
    userEotStatus: state.appData.userEotStatus,
    jErrorcode: state.appData.jErrorcode,
    arrFixtures: state.appData.arrFixtures,
    objMix: state.appData.objMix,
    isShowPullToRefresh: state.appData.isShowPullToRefresh,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    transFetchData: () => dispatch(transFetchData()),
    transFetchData: () => dispatch(transFetchData()),
    fixturesFetchData: (payload) => dispatch(fixturesFetchData(payload)),
    mixFetchData: (payload) => dispatch(mixFetchData(payload)),
    getUserPlayedGameDays: () => dispatch(getUserPlayedGameDays()),
    showHidePopup: (payload) => dispatch(showHidePopup(payload)),
    getMy11LoginDetails: (payload) => dispatch(getMy11LoginDetails(payload)),
    postApiMy11Logout: () => dispatch(postApiMy11Logout()),
    fetchBoostersCon: (payload) => dispatch(fetchBoostersCon(payload)),
    fetchBadges: (payload) => dispatch(fetchBadges(payload)),
    fetchUserBadges: (payload) => dispatch(fetchUserBadges(payload)),
    setWrapperRef: (payload) => dispatch(setWrapperRef(payload)),
    resetStore: (payload) => dispatch(resetStore(payload)),
    fetchConfigData: (payload) => dispatch(fetchConfigData(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Wrapper);
